
export const USER_SYSTEM_COMPATIBILITY_INDEX = 1;

export const ADMIN_DASHBOARD_ROUTE: string = '/admin-dashboard';
export const LANDING_PAGE_ROUTE: string = '/';
export const TEST_COMPONENTS_ROUTE: string = '/test';
export const SIGNUP_ROUTE: string = '/signup';
export const SIGNUP_UPDATE_PROFILE_ROUTE: string = '/signup-update-profile';
export const LOGIN_ROUTE: string = '/login';
export const RESET_PASSWORD_ROUTE: string = '/reset-password';
export const FORGOT_PASSWORD_ROUTE: string = '/forgot-password';
export const VERIFY_EMAIL_ROUTE: string = '/verify-email';
export const DASHBOARD_ROUTE: string = '/dashboard';
export const CREATE_NEW_PROJECT_ROUTE: string = '/create-new-project';
export const USER_PROFILE_ROUTE: string = '/profile';
export const NOT_FOUND_404_ROUTE: string = '/404';
export const FIND_COLLABORATORS_ROUTE: string = '/find-collaborators';
export const MY_PROJECTS_ROUTE: string = '/projects';
export const PROJECT_DETAILS_ROUTE: string = '/project-details';
export const TASKS_ROUTE: string = '/tasks';
export const SETTINGS_ROUTE: string = '/settings';

export const CHAT_ROUTE: string = '/chat';
export const PARTNERS_AND_AFFILIATES_ROUTE: string = '/partners-and-benefits';
export const PRICING_ROUTE: string = '/pricing';
export const ACCOUNT_DASHBOARD_ROUTE: string = '/account-dashboard';
export const CONTACT_SUPPORT_ROUTE: string = '/contact-support';
export const CONTACT_SALES_ROUTE: string = '/contact-sales';

export const ROUTE_TITLE_MAP = {
  [ADMIN_DASHBOARD_ROUTE]: 'Admin Dashboard',
  [LANDING_PAGE_ROUTE]: 'Gamers Home',
  [TEST_COMPONENTS_ROUTE]: 'Test Components',
  [SIGNUP_ROUTE]: 'Signup',
  [LOGIN_ROUTE]: 'Login',
  [RESET_PASSWORD_ROUTE]: 'Reset Password',
  [FORGOT_PASSWORD_ROUTE]: 'Forgot Password',
  [VERIFY_EMAIL_ROUTE]: 'Verify Email',
  [DASHBOARD_ROUTE]: 'Dashboard',
  [USER_PROFILE_ROUTE]: 'User Profile',
  [NOT_FOUND_404_ROUTE]: '404 Not Found',
  [FIND_COLLABORATORS_ROUTE]: 'Find Collaborators',
  [MY_PROJECTS_ROUTE]: 'My Projects',
  [PROJECT_DETAILS_ROUTE]: 'Project Details',
  [TASKS_ROUTE]: 'Tasks',
    [CHAT_ROUTE]: 'Chat',
    [SETTINGS_ROUTE]: 'Settings',
    [PARTNERS_AND_AFFILIATES_ROUTE]: 'Partners and Affiliates',
  [PRICING_ROUTE]: 'Pricing',
  [CREATE_NEW_PROJECT_ROUTE]: 'Create New Project',
  [ACCOUNT_DASHBOARD_ROUTE]: 'Account',
  [CONTACT_SUPPORT_ROUTE]: 'Contact Support',
  [CONTACT_SALES_ROUTE]: 'Contact Sales'
};
